import styled from '@emotion/styled'
import classNames from 'classnames'
import React from 'react'

import vkgLogoStackedOnDarkSrc from 'img/vkg-logo-stacked-on-dark.svg'
import vkgLogoStackedSrc from 'img/vkg-logo-stacked.svg'

export default function LandingPageHeader({ dark = true, sticky = false }) {
  return (
    <Header className={classNames({ dark, sticky })}>
      <img
        className="logo"
        src={dark ? vkgLogoStackedOnDarkSrc : vkgLogoStackedSrc}
        alt="Visa Kings Global logo"
        height={42}
      />
    </Header>
  )
}

const Header = styled.header`
  display: flex;
  justify-content: center;
  padding-top: 8px;
  padding-bottom: 8px;

  background: #fff;

  &.sticky {
    position: sticky;
    top: 0;
    box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.15);
    z-index: 100;
  }

  &.dark {
    background: ${(p) => p.theme.colors.primary};

    .logo {
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35));
    }
  }

  @media (min-width: 640px) {
    padding-top: 18px;
    padding-bottom: 16px;
  }
`
